import React from 'react';
import { useMotionMode } from '../../contexts/MotionContext';

const BRANDS = [
  { name: 'ITV', src: '/brands/itv.png', h: 'h-10' },
  { name: 'Manchester City FC', src: '/brands/man-city.svg', h: 'h-14' },
  { name: 'Manchester United FC', src: '/brands/man-utd.svg', h: 'h-14' },
  { name: 'NHS', src: '/brands/nhs.svg', h: 'h-8' },
  { name: 'AstraZeneca', src: '/brands/astrazeneca.svg', h: 'h-9' },
  { name: 'Rolls-Royce', src: '/brands/rolls-royce.svg', h: 'h-14' },
  { name: 'Silverstone', src: '/brands/silverstone.png', h: 'h-7' },
  { name: 'Celsius', src: '/brands/celsius.png', h: 'h-8' },
  { name: 'Adidas', src: '/brands/adidas.svg', h: 'h-10' },
];

const Logo = ({ b, i }) => (
  <div className="shrink-0 px-8 md:px-12 flex items-center justify-center h-20" data-testid={`brand-logo-${i}`}>
    <img
      src={b.src}
      alt={b.name}
      title={b.name}
      className={`${b.h} w-auto object-contain grayscale opacity-50 hover:grayscale-0 hover:opacity-100 hover:scale-110 transition-[filter,opacity,transform] duration-500`}
      draggable={false}
    />
  </div>
);

export const BrandLogos = () => {
  const { reduced } = useMotionMode();
  return (
    <section className="py-14 bg-white border-b border-gray-200 overflow-hidden" data-testid="brand-logos">
      <p className="text-center text-xs uppercase tracking-[0.35em] text-gray-500 mb-8">Trusted by</p>
      {reduced ? (
        <div className="flex flex-wrap justify-center max-w-6xl mx-auto">{BRANDS.map((b, i) => <Logo key={b.name} b={b} i={i} />)}</div>
      ) : (
        <div className="[mask-image:linear-gradient(to_right,transparent,black_10%,black_90%,transparent)]">
          <div className="flex w-max oc-marquee" style={{ animationDuration: '45s' }} data-testid="brand-logos-track">
            {[...BRANDS, ...BRANDS].map((b, i) => <Logo key={i} b={b} i={i} />)}
          </div>
        </div>
      )}
    </section>
  );
};
